import styled from 'styled-components';

export const ErrorMessage = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #c4314b;
  margin-left: 0.5rem;
`;

export const ErrorrContainer = styled.div`
  height: 10px;
`;
